// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"9c70329b","453":"38b63bc0"}[chunkId] + ".chunk.js";
};